import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import warehouseService from 'api/warehouse.service';
import { find, get, map } from 'lodash';
import { parseJSON } from 'utils';

interface ISetState {
  dataList?: Customer;
  isLoading?: boolean;
}

interface IQueryError {
  message: string;
}

export interface WarehouseState {
  dataList?: any;
  isLoading: boolean;
  errors?: string[];
  selectedTab: string;
  selectedShipments: any;
  warehousemanList: any;
}

const initialState: WarehouseState = {
  isLoading: false,
  errors: null,
  dataList: [],
  selectedTab: '',
  selectedShipments: [],
  warehousemanList: [],
};

const slice = createSlice({
  name: 'warehouse',
  initialState: initialState,
  reducers: {
    setState(state: WarehouseState, { payload }: PayloadAction<ISetState>) {
      state.isLoading = payload.isLoading;
      if (payload.dataList) {
        state.dataList = payload.dataList;
      }
    },
    updateSelectedShipment(
      state: WarehouseState,
      { payload }: PayloadAction<any>
    ) {
      state.selectedShipments = payload;
    },
    warehousemanList(state: WarehouseState, { payload }: PayloadAction<any>) {
      const { warehouseman, assignedWarehouse } = payload;
      state.warehousemanList = map(warehouseman, (wm) => {
        const assigned = find(assignedWarehouse, (a) => a.field2int === wm.id);
        return {
          ...wm,
          warehouses: assigned ? parseJSON(assigned.attr, []) : [],
        };
      });
    },
    updateSelectedTab(
      state: WarehouseState,
      { payload }: PayloadAction<string>
    ) {
      state.selectedTab = payload;
    },
  },
});

export const {
  setState,
  updateSelectedShipment,
  updateSelectedTab,
  warehousemanList,
} = slice.actions;

export default slice.reducer;

export const fetchWarehousemanList = (params) => async (dispatch) => {
  try {
    const response = await warehouseService.fetchWarehousemanList(params);
    const transformedResponseData = get(response, 'data', {});
    dispatch(warehousemanList(transformedResponseData));
  } catch (err) {
    console.error('Error', err);
  } finally {
  }
};
